import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

	static targets = [
		'itemContainer',
	]

	add(event) {
		const templateId = event.currentTarget.dataset.templateId
		const template = document.getElementById(templateId)
		const templateContent = template.content.cloneNode(true)
		this.itemContainerTarget.appendChild(templateContent)
	}

}
